var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAngleDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 2,
    viewBox: "0 0 3 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0660346 0.0650078C0.108329 0.0233834 0.165686 0 0.22549 0C0.285295 0 0.342651 0.0233834 0.384946 0.0650078L1.50136 1.16406L2.61778 0.0650078C2.66031 0.024563 2.71729 0.0021834 2.77642 0.00268928C2.83556 0.00319516 2.89212 0.026546 2.93394 0.0677125C2.97576 0.108879 2.99948 0.164567 2.99999 0.222783C3.00051 0.280999 2.97777 0.337085 2.93669 0.37896L1.66082 1.63499C1.61852 1.67662 1.56117 1.7 1.50136 1.7C1.44156 1.7 1.3842 1.67662 1.34191 1.63499L0.0660346 0.37896C0.0237527 0.337323 0 0.280859 0 0.221984C0 0.163109 0.0237527 0.106645 0.0660346 0.0650078V0.0650078Z",
    fill: "#9C9C9C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleDown);
export default __webpack_public_path__ + "static/media/angleDown.ce8f7b1e3e32d36bdeb394746ff75cc6.svg";
export { ForwardRef as ReactComponent };